/**
 * Typed IMFile.customParams keys used by the web client.
 * Protocol type is Record<string, string>; media size lives in one dedicated field.
 */
export const IM_FILE_CUSTOM_PARAM_KEYS = {
  /** Image/video pixel size. Value: JSON `{"width":number,"height":number}`. */
  mediaSize: 'mediaSize',
} as const

export type ImFileCustomParamKey = typeof IM_FILE_CUSTOM_PARAM_KEYS[keyof typeof IM_FILE_CUSTOM_PARAM_KEYS]

/** Parsed media size (pixels). */
export type ImFileMediaSize = {
  width: number
  height: number
}

/** Wire value stored in customParams.mediaSize (JSON string). */
export type ImFileMediaSizePayload = ImFileMediaSize

/** customParams fragment that carries media dimensions. */
export type ImFileMediaSizeCustomParams = {
  [IM_FILE_CUSTOM_PARAM_KEYS.mediaSize]: string
}
